import type { Ref } from 'vue';

import { computed, ref, watch } from 'vue';
import { format, toZonedTime } from 'date-fns-tz';

import { useUserStore } from '@/stores/useUserStore';

export default function useDateTitle(
  timestampCb: () => string | undefined,
): Ref<string> {
  const userStore = useUserStore();
  const userTimeZone = computed(() => userStore.user.timezone);
  const dateTitle = ref('');
  watch(
    timestampCb,
    (timestamp) => {
      if (typeof timestamp === 'string' && timestamp.length > 0) {
        dateTitle.value = format(
          toZonedTime(new Date(timestamp), userTimeZone.value),
          'EEEE dd, hh:mm aa',
        );
      } else {
        dateTitle.value = '';
      }
    },
    { immediate: true },
  );
  return dateTitle;
}
